import {
    recountTotal, IFetchPostDataType,
} from "../commonMobile";
import { IGameObjectType, IGameType } from "@/types/GlobalTypes";

// COMMON M29 FUNCTIONS
//Shio balls animal row
function addAnimal(e: any) {
    const pcode = e.currentTarget.getAttribute("pcode");
    const animal = e.currentTarget.getAttribute("animal");

    const games: IGameObjectType = this.state.games;
    const game = games[pcode];
    const activeBetGroup = game.activeBetGroup;

    if (!activeBetGroup)
        return;

    //C3 Set or 3D Set
    const isSet = activeBetGroup.indexOf("set") >= 0;
    const isColok = activeBetGroup.indexOf("c") >= 0;

    const maximumAnimalCount = isSet ? 3 :
        Number(activeBetGroup[1]);

    //Scans for one empty element first, then assigns the animal there
    const activeUnsubmittedTicketRow = game.activeUnsubmittedTicketRow;
    const item = game.groupedUnsubmittedTickets
        [activeBetGroup]
        [activeUnsubmittedTicketRow];

    //Prevents duplicate animal on Colok (random)
    if (isColok && item.animals.indexOf(animal) >= 0)
        return;

    //Counts animals in the row
    const animalCount = item.animals.filter(_animal => _animal !== null).length;
    if (animalCount >= maximumAnimalCount) {
        game.activeUnsubmittedTicketRow++;
        return;
    }

    for (let b = item.animals.length - 1; b >= 0; b--)
        if (!item.animals[b]) {
            item.animals[b] = animal;

            game.betHistory.push({
                type: "addAnimal",
                unsubmittedTicketIdx: game.activeUnsubmittedTicketRow,
                animalIdx: b,
            });

            break;
        }

    this.checkController(game); //addAnimal

    this.setState({ games: games });
}

//Shio Balls remove animal from unsubmitted tickets
function removeAnimal(e: any) {
    const pcode = e.currentTarget.getAttribute("pcode");
    const unsubmittedTicketIdx = e.currentTarget.getAttribute("ticketindex");
    const animalIdx = e.currentTarget.getAttribute("animalindex");

    const games: IGameObjectType = this.state.games;
    const game = games[pcode];
    const activeBetGroup = game.activeBetGroup;

    const animal = game.groupedUnsubmittedTickets[activeBetGroup]
        [unsubmittedTicketIdx]
        .animals[animalIdx];

    //Pushes to betHistory (for clickUndo)
    game.betHistory.push({
        type: "removeAnimal",
        unsubmittedTicketIdx: unsubmittedTicketIdx,
        animalIdx: animalIdx,
        animal: animal
    });

    //Cleans the animal cage
    game.groupedUnsubmittedTickets[activeBetGroup]
        [unsubmittedTicketIdx]
        .animals[animalIdx] = null;

    this.checkController(game); //addAnimal

    this.setState({ games: games });
}

//Summary:
//  Submit bet.
//Parameters:
//  game: the game object from fetchGameList
//  fetchPostData: the data that will be sent to the server via fetch post
//    for usage, see clickSubmit() on Lobby or MaximizeMobileGame component
function applyM29SubmitTickets(game: IGameType, fetchPostData: IFetchPostDataType) {
    recountTotal(game);

    if (game.totalBet === 0)
        return;

    Object.keys(game.groupedUnsubmittedTickets).forEach((group: string) => {
        //Removes unsubmitted tickets if the bet amount is 0
        //Validates for empty bets and empty ticket rows
        game.groupedUnsubmittedTickets[group] = game.groupedUnsubmittedTickets[group].filter(ticket =>
            ticket.bet > 0 &&
            ticket.animals.filter(animal => animal !== null).length > 0
        );

        const isSet = group.indexOf("set") >= 0;
        const isColok = group.indexOf("c") >= 0;

        if (!isSet) {
            //Change the type from 3D to 2D or 1D depending on the animals that are left after filtration.

            //Example:
            //Pattern:
            //  [animals]: type

            //  snake, goat, horse: 3D
            //  This set is complete, therefore submit all

            //  snake, goat: 3D
            //  This set is incomplete, therefore change the type to 2D

            //  snake: 2D
            //  This set is incomplete, therefore change the type to 1D

            game.groupedUnsubmittedTickets[group].forEach(utTicket => {
                const filteredAnimals = utTicket.animals.filter(animal => animal !== null);
                const filteredAnimalLength = filteredAnimals.length;

                //Possible groups after filter:
                //  c1d1 - c3d1
                //  d1 - d3
                const groupAfterFilter = isColok ? `c${filteredAnimalLength}d1` :
                    `d${filteredAnimalLength}`;

                //Filters ticket object for the same tebak
                const filtered = game.tickets.filter(tTicket =>
                    tTicket.type === groupAfterFilter &&
                    tTicket.tebak === filteredAnimals.join(","));

                //Inserts a new ticket if there's no same ticket
                if (filtered.length === 0) {
                    //Push ticket
                    game.tickets.push({
                        tebak: filteredAnimals.join(","),
                        taruhan: utTicket.bet,
                        periode: game.periode,
                        type: groupAfterFilter
                    });

                    return;
                }

                //Adds ticket bet when there's already the same 'tebak'
                const ticketItem = game.tickets[game.tickets.indexOf(filtered[0])];
                ticketItem.taruhan += utTicket.bet;
                // ticketItem.taruhan += utTicket.bet; //accumulated 'taruhan'
            });
        } else {
            //Generate bets for:
            //- c1d1 to c3d1
            //- d1 to d3

            // c3set or 3dset

            let a = 0;

            //Only submit complete sets.

            //Set 1:
            // snake, horse, goat: 3D Set
            // Submit the whole set

            //Set 2:
            // snake, horse: 3D set
            // Don't submit 3D, therefore submit only 2D and 1D

            game.groupedUnsubmittedTickets[group].forEach((utTicket) => {
                //Immediately use filteredAnimals as array
                const filteredAnimals = utTicket.animals.filter(animal => animal !== null);
                const filteredAnimalLength = filteredAnimals.length;

                //Inserts & checks tickets if there is any same tickets
                for (a = 1; a <= filteredAnimalLength; a++) {
                    const slicedAnimals = filteredAnimals.slice(filteredAnimalLength - a, filteredAnimalLength);

                    //Todo: copy this method to commonM30, 5D Set
                    const betType = isColok ? `c${a}d1` : `d${a}`;

                    //Filters ticket object for the same tebak
                    const filtered = game.tickets.filter(tTicket =>
                        tTicket.type === betType &&
                        tTicket.tebak === slicedAnimals.join(","));

                    const indexOfFiltered = game.tickets.indexOf(filtered[0]);

                    //Adds paid bet on the already available bets
                    if (indexOfFiltered >= 0) {
                        game.tickets[indexOfFiltered]
                            .taruhan += utTicket.bet;

                        continue;
                    }

                    //Generates tickets
                    game.tickets.push({
                        tebak: slicedAnimals.join(","),
                        taruhan: utTicket.bet,
                        periode: game.periode,

                        //use either cNd1 or dN for type
                        type: betType
                    });
                }
            });
        }
    });




    let totalBet = 0;

    //Applies tickets to submitted data
    game.tickets.forEach(item => {
        fetchPostData.button_bet.push({
            //Send the data the same as what the player sees
            button: item.tebak.split(",").filter(animal => animal !== "").join(","),
            group: item.type,
            value: item.taruhan
        });

        //console.log("fPD bb", fetchPostData.button_bet);

        totalBet += Number(item.taruhan);
    });


    fetchPostData.total_bet = totalBet;
}

export {
    addAnimal,
    removeAnimal,

    applyM29SubmitTickets,
};
